// providers/ImportStatus/importStatus.reducer.js
import { IMPORT_ACTIONS, INITIAL_STATE, isCodeChangeWarning } from './importStatus.constants';
/**
 * Main reducer for import state management
 */
export const importReducer = (state, action) => {
  switch (action.type) {
    case IMPORT_ACTIONS.SET_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case IMPORT_ACTIONS.SET_JOB_ID:
      return {
        ...state,
        jobId: action.payload,
      };
    case IMPORT_ACTIONS.SET_RESULT:
      // When receiving a result, also set jobId and check if modal should open
      const shouldOpenModal = isCodeChangeWarning(action.payload.result);
      return {
        ...state,
        result: action.payload.result,
        jobId: action.payload.jobId,
        messageToDisplayInResult: action.payload.result?.message || null,
        isOpenChangeCodeModal: shouldOpenModal,
      };
    case IMPORT_ACTIONS.SET_IMPORT_CONFIG:
      // Grouped configuration at import start
      return {
        ...state,
        importFrom: action.payload.importFrom ?? state.importFrom,
        importType: action.payload.importType ?? state.importType,
        importOriginLocation: action.payload.importOriginLocation ?? state.importOriginLocation,
        nextCampaignChosen: action.payload.nextCampaignChosen ?? state.nextCampaignChosen,
      };
    case IMPORT_ACTIONS.SET_GEOFOLIA_STEP:
      return {
        ...state,
        geofoliaImportSteps: action.payload,
      };
    case IMPORT_ACTIONS.OPEN_CODE_CHANGE_MODAL:
      return {
        ...state,
        isOpenChangeCodeModal: true,
      };
    case IMPORT_ACTIONS.CLOSE_CODE_CHANGE_MODAL:
      return {
        ...state,
        isOpenChangeCodeModal: false,
      };
    case IMPORT_ACTIONS.SET_MESSAGE_TO_DISPLAY:
      return {
        ...state,
        messageToDisplayInResult: action.payload,
      };
    case IMPORT_ACTIONS.RESET:
      return INITIAL_STATE;
    default:
      console.warn(`Action non gérée: ${action.type}`);
      return state;
  }
};
/**
 * Action creator functions
 * Facilitate dispatch usage with a clear API
 */
export const importActions = {
  setStatus: (status) => ({
    type: IMPORT_ACTIONS.SET_STATUS,
    payload: status,
  }),
  setJobId: (jobId) => ({
    type: IMPORT_ACTIONS.SET_JOB_ID,
    payload: jobId,
  }),
  setResult: (result, jobId) => ({
    type: IMPORT_ACTIONS.SET_RESULT,
    payload: { result, jobId },
  }),
  setImportConfig: ({ importFrom, importType, importOriginLocation, nextCampaignChosen }) => ({
    type: IMPORT_ACTIONS.SET_IMPORT_CONFIG,
    payload: { importFrom, importType, importOriginLocation, nextCampaignChosen },
  }),
  setGeofoliaStep: (step) => ({
    type: IMPORT_ACTIONS.SET_GEOFOLIA_STEP,
    payload: step,
  }),
  openCodeChangeModal: () => ({
    type: IMPORT_ACTIONS.OPEN_CODE_CHANGE_MODAL,
  }),
  closeCodeChangeModal: () => ({
    type: IMPORT_ACTIONS.CLOSE_CODE_CHANGE_MODAL,
  }),
  setMessageToDisplay: (message) => ({
    type: IMPORT_ACTIONS.SET_MESSAGE_TO_DISPLAY,
    payload: message,
  }),
  reset: () => ({
    type: IMPORT_ACTIONS.RESET,
  }),
};
